<template>
  <b-modal v-model="modal" centered no-close-on-esc no-close-on-backdrop>
    <h5 class="modal-title" slot="modal-header">
      <i class="mdi mdi-harddisk"></i> Armazenamento
    </h5>
    <b-form-group
        label="Diretório Base"
        label-for="dirBase"
        description="O diretório base do servidor de armazenamento"
    >
      <b-form-input
          type="text"
          id="dirBase"
          class="col col-lg-12"
          v-model="valor.dirBase"
          size="sm"
          autocomplete="off"
          :state="!$v.valor.dirBase.$error"
      ></b-form-input>
      <b-form-invalid-feedback
      >Este Campo &eacute; requerido.</b-form-invalid-feedback
      >
    </b-form-group>

    <!--    <b-form-group
          label="Tempo de Retenção"
          label-for="tempoRetencao"
          description="O tempo retido das imagens em: Dias, Semanas, Meses ou Anos"
          :state="!$v.valor.tempoRetencao.$error"
        >
          <tempo-retencao-input
            v-model="valor.tempoRetencao"
            :state="!$v.valor.tempoRetencao.$error"
          />
        </b-form-group>-->

    <!--    <b-form-group label="Ativo" label-for="ativo">
          <toggle-button v-model="valor.ativo" :sync="true" />
        </b-form-group>-->

    <div class="w-100" slot="modal-footer">
      <b-button
          @click="fecharModal"
          variant="default"
          size="sm"
          class="float-left"
      >Cancelar</b-button
      >
      <b-button @click="salvar" variant="success" size="sm" class="float-right">
        <i class="mdi mdi-check-circle"></i> Salvar Dispositivo
      </b-button>
    </div>
  </b-modal>
</template>
<script>
import {required} from "vuelidate/lib/validators";

//import TempoRetencaoInput from "./TempoRetencaoInput.vue";
import ServidorApi from "@/api/servidorApi";

export default {
  name: "armazenamentoModal",
  //components: { TempoRetencaoInput },
  model: {
    prop: "mostrarModal",
    event: "change"
  },
  props: {
    armazenamento: {
      type: Object,
      required: true
    },
    mostrarModal: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      modal: this.mostrarModal,
      valor: this.armazenamento
    };
  },
  validations: {
    valor: {
      dirBase: { required },
      //tempoRetencao: { required }
    }
  },
  watch: {
    mostrarModal(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      if (newVal) this.$v.$reset();
      this.modal = newVal;
      this.valor = this.armazenamento;
    }
  },
  methods: {
    fecharModal() {
      this.modal = false;
      this.$emit("change", false);
      this.valor = {
        id: "",
        dirBase: "",
        /*tempoRetencao: "",
        url: ""*/
      };
    },
    salvar() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.info("Invalido");
        return;
      }

      this.salvando = true;
      let armazenamento = this.valor;
      ServidorApi.salvarArmazenamento(armazenamento)
          .then(resp => {
            this.salvando = false;
            armazenamento.id = resp.data.id;
            this.$emit("salvar", armazenamento);
            this.fecharModal();
          })
          .catch(e => {
            console.log(e);
            this.salvando = false;
          });
    }
  }
};
</script>
<style lang="scss">
.form-group.is-invalid div span .invalid-feedback {
  display: block;
}
</style>
